import Model from "../../Model";
//import { actions } from '@/store';

class singleProducts extends Model{

    buildUrl ({ param }) {

        return ['stock/products/', param];
    }

    all(config = {}) {
        return this.request({
            method: 'GET',
            action: 'all',
            url: 'stock/products/'+config.query.id
            });
    }

    afterRequest({ data }) {
        return data;
    }
}


export default new singleProducts;